import PaymentsPageContent from '../components/financial/payments/paymentsPageContent';

const PaymentsPage = () => {
  return <PaymentsPageContent />;
};

export default PaymentsPage;